import React from "react";

function SanctionForeclosureCharges() {
    return (
        <>
            <div className="relative w-full">
                <ul className="list-disc pl-5">
                    <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                        No foreclosure allowed within 6 months from date of
                        availing the car loan 6% of Principal Outstanding for
                        pre-closures within 1 year from 7th EMI
                    </li>
                    <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                        5% of Principal Outstanding for pre-closures within
                        13-24 months from 1st
                    </li>
                    <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1">
                        EMI 3% of Principal Outstanding for pre-closures post 24
                        months from 1st EMI
                    </li>
                </ul>
            </div>
        </>
    );
}

export default SanctionForeclosureCharges;
